/** Empty stub: cornerstone-wado-image-loader only `require`s `fs` on Node; browser never calls it. */
module.exports = {};
